import {AppMenuIcon, AppMenuItem} from './app-menu.model';

const FA_TO_PRIME_ICON: Record<string, string> = {
	'calendar-edit': 'pi pi-calendar-plus',
	'calendar': 'pi pi-calendar',
	'file-invoice': 'pi pi-file',
	'warehouse': 'pi pi-warehouse',
	'boxes-stacked': 'pi pi-truck',
	'user': 'pi pi-users',
	'money-bill-wave': 'pi pi-money-bill',
	'sack-dollar': 'pi pi-wallet',
	'utensils': 'pi pi-shopping-bag',
	'tools': 'pi pi-wrench',
	'euro-sign': 'pi pi-euro',
	'cog': 'pi pi-cog',
	'chart-pie': 'pi pi-chart-pie',
	'chart-line': 'pi pi-chart-line',
	'envelope': 'pi pi-envelope',
	'clipboard-list': 'pi pi-check-square',
	'bread-slice': 'pi pi-box',
	'toolbox': 'pi pi-wrench',
	'refrigerator': 'pi pi-snowflake',
	'headset': 'pi pi-headphones',
	'sparkles': 'pi pi-sparkles',
	'circle-question': 'pi pi-question-circle',
};

export function appMenuIconClass(icon?: string | AppMenuIcon): string | null {
	if (!icon) {
		return null;
	}

	if (typeof icon === 'string') {
		return icon.startsWith('pi ') ? icon : `pi pi-${icon}`;
	}

	if (icon.pack === 'prime' || icon.icon.startsWith('pi-')) {
		return icon.icon.startsWith('pi ') ? icon.icon : `pi ${icon.icon}`;
	}

	const mapped = FA_TO_PRIME_ICON[icon.icon];
	if (mapped) {
		return mapped;
	}

	const pack = icon.pack || 'regular';
	const prefix = pack === 'duotone' ? 'fad' :
		pack === 'solid' ? 'fas' :
			pack === 'light' ? 'fal' :
				pack === 'brands' ? 'fab' : 'far';
	return `${prefix} fa-${icon.icon}`;
}

export function filterVisibleMenuItems(items: AppMenuItem[]): AppMenuItem[] {
	return items
		.filter((item) => !item.hidden)
		.map((item) => ({
			...item,
			children: item.children ? filterVisibleMenuItems(item.children) : undefined,
		}))
		.filter((item) => !item.children || item.children.length > 0 || !!item.link);
}
